import type { Dispatch, SetStateAction } from 'react';

import { useCallback, useState } from 'react';

export type PortalTargetMap = Map<string, HTMLElement>;

export function usePortalTargetMap(): {
  targets: PortalTargetMap;
  register: (id: string, el: HTMLElement) => void;
  unregister: (id: string) => void;
  setTargets: Dispatch<SetStateAction<PortalTargetMap>>;
} {
  const [targets, setTargets] = useState<PortalTargetMap>(() => new Map());

  const register = useCallback((id: string, el: HTMLElement) => {
    setTargets((prev) => {
      const next = new Map(prev);
      next.set(id, el);
      return next;
    });
  }, []);

  const unregister = useCallback((id: string) => {
    setTargets((prev) => {
      if (!prev.has(id)) return prev;

      const next = new Map(prev);
      next.delete(id);
      return next;
    });
  }, []);

  return { targets, register, unregister, setTargets };
}
